import { render, staticRenderFns } from "./CustomerAddress.vue?vue&type=template&id=9b73a67a&scoped=true"
import script from "./CustomerAddress.vue?vue&type=script&lang=js"
export * from "./CustomerAddress.vue?vue&type=script&lang=js"
import style0 from "./CustomerAddress.vue?vue&type=style&index=0&id=9b73a67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b73a67a",
  null
  
)

export default component.exports